import { Component, OnInit } from '@angular/core';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { MaStateMappingService } from 'src/app/Services/admin-rights/ma-state-mapping.service';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector : 'app-ma-state-mapping',
  templateUrl : './ma-state-mapping.component.html',
  styleUrls : ['./ma-state-mapping.component.css']
})
export class MaStateMappingComponent implements OnInit {
  ma : any;
  state : any[];
  maState : any[];
  loader : string = 'none';

  constructor(private maStateService : MaStateMappingService, private router: Router, private snackBar : MatSnackBarComponent,private toastr: ToastrService) { }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getMAStateMapping();
  }

  getMAStateMapping(){
    this.loader = 'block';
    this.maStateService.getMAStateMapping('')
    .subscribe((resdata : any) =>{
      if(resdata.status == true){
        this.ma = resdata.data.ma;
        this.state = resdata.data.states;
        this.loader = 'none';
      }
      else
      {
        this.toastr.error(resdata.msg);
        this.loader = 'none';
      }
    })
  }

  getState(selectedMA : any){
    this.state.forEach(function (detail) {
      if(detail.ma == selectedMA){
        this.maState = detail.states
      }
    })
  }
}
